// import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import React from 'react';

const ContentCard = ({
  cardAction,
  project,
  isFeatured,
  handleActiveProject,
  navigate,
  searchParameters,
}: {
  cardAction: string;
  project: Project;
  isFeatured: boolean;
  handleActiveProject: HandleActiveProject;
  navigate: Navigate;
  searchParameters: URLSearchParams;
}) => {
  const { title, description, image } = project;

  return (
    <Card
      className={`card${isFeatured ? '' : ' dashboard-card'}`}
      onClick={() => handleActiveProject(title, navigate, searchParameters)}
    >
      <CardHeader
        classes={{
          root: 'card-header',
        }}
        disableTypography={true}
        title={<Typography className="card-header-title">{title}</Typography>}
      />
      <CardMedia
        classes={{ root: 'card-media' }}
        component="img"
        image={image}
        alt={`${title} Icon`}
      />
      <CardContent
        classes={{
          root: 'card-content',
        }}
      >
        <Typography className="card-description">{description}</Typography>
      </CardContent>
      <CardActions
        classes={{
          root: 'card-actions',
        }}
        disableSpacing
      >
        <Button className="card-actions-button" size="small">
          {/* {<ShareOutlinedIcon classes={{ root: 'card-actions-button-icon' }} />} */}
          {cardAction}
        </Button>
      </CardActions>
    </Card>
  );
};

export default ContentCard;
